import React, {
    useContext,
    useEffect,
} from "react"

import {
    Routes,
    Route,
} from "react-router-dom"

import EMETLAssessmentManager from "../../../Model/EMETLAssessment.m"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import PAGES from "../../../Model/EMETLPages.m"
import EMETLBanner from "../EMETLBanner"
import EMETLNavBar from "../EMETLNavBar"

import Dashboard from "../../Dashboard"
import EMETL404 from "../../EMETL404"
import EMETLModal from "../EMETLModal"

import "./style.css"
import AssessmentTaskSubtasks from "../../AssessmentTaskSubTasks"
import AssessmentTaskPerformanceSteps from "../../AssessmentTaskPerformanceSteps"
import AssessmentTaskSubTaskPerformanceSteps from "../../AssessmentTaskSubTaskPerformanceSteps"
import EMETLLoadingView from "../EMETLLoadingView"
import QuarterlyData from "../../Quarterly"
import Templates from "../../Templates"

const EMETLRoutes = () => {
    const {
        modal: {
            content,
        },
        loading: {
            value: isLoading,
            update: setLoading,
            setMessage,
        },
        staticTasksAndPS: {
            update: setStaticTasksAndPS,
        },
        units: {
            update: setUnits,
        },
    } = useContext(Context)

    const load = async () => {
        setLoading(true)
        setMessage("Loading your available units")
        const u = await EMETLAssessmentManager.listUnitsForUser()
        setUnits(u)
        setMessage("Loading the static task and performance step structure")
        const tasksAndPS = await EMETLAssessmentManager.loadStaticTasksAndPS()
        if (tasksAndPS === false) {
            setLoading(false)
            setMessage("Error loading static task and performance step structure.")
            return
        }
        setStaticTasksAndPS(tasksAndPS)
        setLoading(false)
        setMessage("")
    }

    useEffect(() => {
        load()
    }, [])

    const Page = ({ pageName }) => (
        <>
            <div
                style={{
                    paddingTop: "21px",
                    paddingBottom: "21px",
                }}
            >
                {PAGES.find(p => p.name === pageName)?.page}
            </div>
        </>
    )

    return (
        <>
            <EMETLNavBar />
            <EMETLBanner />
            <EMETLModal>{content}</EMETLModal>
            {isLoading && (
                <EMETLLoadingView />
            )}
            <Routes>
                <Route
                    path="*"
                    element={
                        <EMETL404 />
                    }
                />
                <Route 
                    index 
                    path="/"
                    element={
                        <Dashboard />
                    } 
                />
                <Route
                    path="/Terms"
                    element={<div>Terms</div>} 
                />
                <Route
                    path="/About"
                    element={<div>About</div>} 
                />
                <Route
                    path="/Feedback"
                    element={<div>Feedback</div>} 
                />
                <Route
                    path="/ContactUs"
                    element={<div>Contact Us</div>} 
                />
                <Route
                    path="/AccountHelp"
                    element={<div>Account Help</div>} 
                />
                <Route
                    path="/Investors"
                    element={<div>Investors</div>} 
                />
                <Route
                    path="/Cogent"
                    element={<div>Cogent</div>} 
                />
                <Route
                    path="/Announcements"
                    element={<div>Announcements</div>} 
                />
                <Route
                    path="/FieldManual"
                    element={<div>FieldManual</div>} 
                />
                <Route
                    path="/Assessment"
                    element={!isLoading ? <Page pageName="CreateAssessment" /> : <></>}
                />
                <Route
                    path="/AssessmentTaskPerformanceSteps"
                    element={<AssessmentTaskPerformanceSteps />} 
                />
                <Route
                    path="/AssessmentTaskSubTaskPerformanceSteps"
                    element={<AssessmentTaskSubTaskPerformanceSteps />} 
                />
                <Route
                    path="/AssessmentTaskSubTasks"
                    element={<AssessmentTaskSubtasks />} 
                />
                <Route
                    path="Quarterly"
                    element={!isLoading ? <QuarterlyData /> : <></>}
                />
                <Route
                    path="Templates"
                    element={!isLoading ? <Templates /> : <></>}
                />
            </Routes>
        </>
    )
}

export default EMETLRoutes
